import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const ConferenceAuction = lazy(
  () => import("@/pages/agent/miscellaneous/conference-auction/ConferenceAuction/ConferenceAuction"),
);

const Error404 = lazy(() => import("@/pages/Error404"));

const miscellaneousRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "conference-auction",
    element: <ConferenceAuction />,
  },
];

export default miscellaneousRoutes;
